<template>
  <div class="personage-grade">
    <div class="main">
      <div class="ranking">当前排名：{{currentRanking}}</div>
      <div class="score">
        个人分数：{{currentScore}}&nbsp;
        <el-tooltip
          effect="dark"
          content="学习的新单词越多，分数越高哦！"
          placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';
import { Tooltip } from 'element-ui';

export default {
  components: {
    ElTooltip: Tooltip,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {},
    },
    isGuardMember: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    matchInfo: {
      handler() {
        if (this.isGuardMember) {
          this.list = this.matchInfo.guard;
        } else {
          this.list = this.matchInfo.offensive;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    currentRanking() {
      const { id } = utils.storage('account');
      const ranking = utils.Array.findIndex(this.list, { id }, 'id') + 1;

      return ranking;
    },
    currentScore() {
      const { id } = utils.storage('account');
      const item = utils.Array.find(this.list, { id }, 'id');

      return item.score;
    },
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>

<style lang="scss" scoped>
  .personage-grade {
    position: fixed;
    bottom: 0;
    left: 90px;
    color: #fff;
    font-size: 3vh;
    font-weight: 700;
    .main {
      display: flex;
      .ranking {
        margin-right: 5vw;
      }
    }
  }
</style>
